/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2
 */
import * as References from './AutomationEmbeddedServiceV2';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2#fetchAllowedActionTypes
 */
export const FETCH_ALLOWED_ACTION_TYPES_QUERY_FIELD_NAME = 'com_hubspot_automation_embedded_rpc_AutomationEmbeddedServiceV2_fetchAllowedActionTypes';
export const FETCH_ALLOWED_ACTION_TYPES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: FETCH_ALLOWED_ACTION_TYPES_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.fetchAllowedActionTypesRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2#fetchAllowedTriggers
 */
export const FETCH_ALLOWED_TRIGGERS_QUERY_FIELD_NAME = 'com_hubspot_automation_embedded_rpc_AutomationEmbeddedServiceV2_fetchAllowedTriggers';
export const FETCH_ALLOWED_TRIGGERS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: FETCH_ALLOWED_TRIGGERS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.fetchAllowedTriggersRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2#fetchPermissions
 */
export const FETCH_PERMISSIONS_QUERY_FIELD_NAME = 'com_hubspot_automation_embedded_rpc_AutomationEmbeddedServiceV2_fetchPermissions';
export const FETCH_PERMISSIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: FETCH_PERMISSIONS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.fetchPermissionsRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2#fetchEmbeddedSummary
 */
export const FETCH_EMBEDDED_SUMMARY_QUERY_FIELD_NAME = 'com_hubspot_automation_embedded_rpc_AutomationEmbeddedServiceV2_fetchEmbeddedSummary';
export const FETCH_EMBEDDED_SUMMARY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: FETCH_EMBEDDED_SUMMARY_QUERY_FIELD_NAME,
  args: ['target', 'relatedAutomationsPageSize', 'allAutomationsPageSize'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.fetchEmbeddedSummaryRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2#fetchRelatedAutomations
 */
export const FETCH_RELATED_AUTOMATIONS_QUERY_FIELD_NAME = 'com_hubspot_automation_embedded_rpc_AutomationEmbeddedServiceV2_fetchRelatedAutomations';
export const FETCH_RELATED_AUTOMATIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: FETCH_RELATED_AUTOMATIONS_QUERY_FIELD_NAME,
  args: ['target', 'flowKinds', 'sourceApps', 'compatibleBuilders', 'sortDirection', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.fetchRelatedAutomationsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2#fetchAllAutomations
 */
export const FETCH_ALL_AUTOMATIONS_QUERY_FIELD_NAME = 'com_hubspot_automation_embedded_rpc_AutomationEmbeddedServiceV2_fetchAllAutomations';
export const FETCH_ALL_AUTOMATIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: FETCH_ALL_AUTOMATIONS_QUERY_FIELD_NAME,
  args: ['flowKinds', 'sourceApps', 'compatibleBuilders', 'sortDirection', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.fetchAllAutomationsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2#searchRelatedAutomations
 */
export const SEARCH_RELATED_AUTOMATIONS_QUERY_FIELD_NAME = 'com_hubspot_automation_embedded_rpc_AutomationEmbeddedServiceV2_searchRelatedAutomations';
export const SEARCH_RELATED_AUTOMATIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_RELATED_AUTOMATIONS_QUERY_FIELD_NAME,
  args: ['target', 'searchQuery', 'flowKinds', 'sourceApps', 'compatibleBuilders', 'sortDirection', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.searchRelatedAutomationsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2#fetchTemplates
 */
export const FETCH_TEMPLATES_QUERY_FIELD_NAME = 'com_hubspot_automation_embedded_rpc_AutomationEmbeddedServiceV2_fetchTemplates';
export const FETCH_TEMPLATES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: FETCH_TEMPLATES_QUERY_FIELD_NAME,
  args: ['target', 'search', 'tags', 'sortBy', 'sortDirection', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.fetchTemplatesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2#fetchWorkflow
 */
export const FETCH_WORKFLOW_QUERY_FIELD_NAME = 'com_hubspot_automation_embedded_rpc_AutomationEmbeddedServiceV2_fetchWorkflow';
export const FETCH_WORKFLOW_QUERY = /* #__PURE__ */registerQuery({
  fieldName: FETCH_WORKFLOW_QUERY_FIELD_NAME,
  args: ['flowId'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.fetchWorkflowRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2#resolveWorkflowLinks
 */
export const RESOLVE_WORKFLOW_LINKS_QUERY_FIELD_NAME = 'com_hubspot_automation_embedded_rpc_AutomationEmbeddedServiceV2_resolveWorkflowLinks';
export const RESOLVE_WORKFLOW_LINKS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: RESOLVE_WORKFLOW_LINKS_QUERY_FIELD_NAME,
  args: ['flowIds', 'baseUrl'],
  fetcher(request, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.resolveWorkflowLinksRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2#resolveRunHistoryLinks
 */
export const RESOLVE_RUN_HISTORY_LINKS_QUERY_FIELD_NAME = 'com_hubspot_automation_embedded_rpc_AutomationEmbeddedServiceV2_resolveRunHistoryLinks';
export const RESOLVE_RUN_HISTORY_LINKS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: RESOLVE_RUN_HISTORY_LINKS_QUERY_FIELD_NAME,
  args: ['targets'],
  fetcher(request, ctx) {
    var _ctx$customClient11;
    return ((_ctx$customClient11 = ctx.customClient) !== null && _ctx$customClient11 !== void 0 ? _ctx$customClient11 : chirpClient).call(References.resolveRunHistoryLinksRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});